import { Component, Input } from '@angular/core'

@Component({
    selector: 'app-upload-progress-bar',
    templateUrl: './upload-progress-bar.component.html',
    styleUrls: ['./upload-progress-bar.component.scss'],
})
export class UploadProgressBarComponent {
    @Input()
    progress: number | undefined
}
